/**
 * The wire shape `Rws.AiInsights.Host.Mcp.McpTokenLifetimeEndpoints` returns: how long the portal's MCP
 * access tokens and refresh tokens last. Gated on `settings.write`. A change applies to tokens issued
 * afterwards; tokens already issued keep their expiry.
 */
import { adminRequest, type AdminResult } from "./adminApi";

/** The three MCP token lifetimes, in the whole units an administrator edits. */
export interface McpTokenLifetimes {
  accessTokenMinutes: number;
  refreshIdleDays: number;
  refreshAbsoluteDays: number;
  /** When the values were last saved, or `null` while the defaults apply. */
  updatedAt: string | null;
}

const mcpTokenLifetimesPath = "/api/entitlement/settings/mcp-token-lifetimes";

/** Calls `GET /api/entitlement/settings/mcp-token-lifetimes`. */
export async function fetchMcpTokenLifetimes(): Promise<AdminResult<McpTokenLifetimes>> {
  return adminRequest<McpTokenLifetimes>(mcpTokenLifetimesPath, { method: "GET" }, "MCP token lifetimes");
}

/** Calls `PUT /api/entitlement/settings/mcp-token-lifetimes`. */
export async function updateMcpTokenLifetimes(
  accessTokenMinutes: number,
  refreshIdleDays: number,
  refreshAbsoluteDays: number,
): Promise<AdminResult<McpTokenLifetimes>> {
  return adminRequest<McpTokenLifetimes>(
    mcpTokenLifetimesPath,
    { method: "PUT", body: JSON.stringify({ accessTokenMinutes, refreshIdleDays, refreshAbsoluteDays }) },
    "MCP token lifetimes update",
  );
}
